import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-footer-powered-by-image",
  templateUrl: "./footer-powered-by-image.component.html",
  styleUrls: ["./footer-powered-by-image.component.scss"],
})
export class FooterPoweredByImageComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  // openWebsite() {
  //   window.open("https://www.zceppa.com/", "_blank");
  // }
}
